import {
	formatDistanceToNow as dateFnsDist,
	format as dateFnsFormat,
} from "date-fns";
import type { Locale } from "date-fns";
import { enUS, ru } from "date-fns/locale";
import { useLocaleStore } from "./locale";

const DATE_FNS_LOCALES: Record<string, Locale> = { ru, en: enUS };

function getLocale() {
	return useLocaleStore.getState().language;
}

function dateFnsLocale() {
	return DATE_FNS_LOCALES[getLocale()] ?? ru;
}

function intlLocale(): string {
	return getLocale() === "ru" ? "ru-RU" : "en-US";
}

// ---------- Date formatting ----------

export function formatDate(
	date: Date | number | string,
	pattern = "d MMM yyyy",
): string {
	return dateFnsFormat(new Date(date), pattern, { locale: dateFnsLocale() });
}

export function formatRelative(date: Date | number | string): string {
	return dateFnsDist(new Date(date), {
		addSuffix: true,
		locale: dateFnsLocale(),
	});
}

// ---------- Number formatting ----------

export function formatNumber(
	value: number,
	opts?: Intl.NumberFormatOptions,
): string {
	return new Intl.NumberFormat(intlLocale(), opts).format(value);
}

export function formatCurrency(
	cents: number | bigint,
	currency = "RUB",
	opts?: Intl.NumberFormatOptions,
): string {
	const value = Number(cents) / 100;
	return new Intl.NumberFormat(intlLocale(), {
		style: "currency",
		currency,
		minimumFractionDigits: 0,
		maximumFractionDigits: 2,
		...opts,
	}).format(value);
}

export function formatPercent(value: number): string {
	return new Intl.NumberFormat(intlLocale(), {
		style: "percent",
		minimumFractionDigits: 0,
		maximumFractionDigits: 1,
	}).format(value);
}
